import { getPayrollApprovedTimesheets } from "../api/v2BatchExport";
import { fetchBatchReports } from "../dataLayer/v1BatchExport";
import { EmployeeTimeSheet } from "../interfaces/V2Interface";

class V2BatchExportManager {

    // Method to get employees by supervisor
    async getEmployees(
        supervisorId: string,
        payPeriodID: number
        ): Promise<EmployeeTimeSheet[]> {
        try {
            const employees = await getPayrollApprovedTimesheets(parseInt(supervisorId), payPeriodID);
            
            // Transform the data to ensure it has altEmployeeID
            return employees.map(emp => ({
            ...emp,
            altEmployeeID: emp.altEmployeeID,
            employeeID: emp.employeeID.toString()
            }));
        } catch (error) {
            console.error("Error getting employees:", error);
            throw error;
        }
    }

    // Method to get batch reports (shared with V1)
    async getBatchReports(batchId: string): Promise<any> {
        try {
            const reports = await fetchBatchReports(batchId);
            return reports;
        } catch (error) {
            console.error("Error getting batch reports:", error);
            throw error;
        }
    }
}

// Exporting an instance of V2BatchExportManager to use throughout the application
export default new V2BatchExportManager();